import { Apple } from './Apple'
import { AtSign } from './AtSign'
import { Board } from './Board'
import { Bookmark } from './Bookmark'
import { BrandedGoogle } from './BrandedGoogle'
import { ChatSelected } from './ChatSelected'
import { ChatUnselected } from './ChatUnselected'
import { DiscoverSelected } from './DiscoverSelected'
import { DiscoverUnselected } from './DiscoverUnselected'
import { Dropdown } from './Dropdown'
import { Facebook } from './Facebook'
import { Google } from './Google'
import { HeartFilled } from './HeartFilled'
import { HomeSelected } from './HomeSelected'
import { HomeUnselected } from './HomeUnselected'
import { Lock } from './Lock'
import { MessagesSelected } from './MessagesSelected'
import { MessagesUnselected } from './MessagesUnselected'
import { NewTab } from './NewTab'
import { NotificationsSelected } from './NotificationsSelected'
import { NotificationsUnselected } from './NotificationsUnselected'
import { OptionsMenu } from './OptionsMenu'
import { Pencil } from './Pencil'
import { Play } from './Play'
import { PostCompleteUpswing } from './PostCompleteUpswing'
import { Reset } from './Reset'
import { SendMessage } from './SendMessage'
import { SessionDumbbell } from './SessionDumbbell'
import { SmallGradientCircle } from './SmallGradientCircle'
import { SmallGradientCircleWithOutline } from './SmallGradientCircleWithOutline'
import { StopWatch } from './StopWatch'
import { TriangleArrow } from './TriangleArrow'
import { Upscore } from './Upscore'
import { Upspace } from './Upspace'
import { UpspaceGradientLogoMark } from './UpspaceGradientLogoMark'
import { UpspaceLogoMark } from './UpspaceLogoMark'
import { UpspaceWordMark } from './UpspaceWordMark'
import { UpswingHorizontal } from './UpswingHorizontal'
import { UpswingVertical } from './UpswingVertical'
import { UserProfile } from './UserProfile'

export const CustomIconExists = (name: string): name is keyof typeof CustomIcons =>
  name in CustomIcons

export const CustomIcons = {
  apple: Apple,
  'at-sign': AtSign,
  'options-menu': OptionsMenu,
  'bookmark-filled': Bookmark,
  'heart-filled': HeartFilled,
  dropdown: Dropdown,
  board: Board,
  facebook: Facebook,
  google: Google,
  brandedGoogle: BrandedGoogle,
  'post-pencil': Pencil,
  'post-lock': Lock,
  'messages-selected': MessagesSelected,
  'messages-unselected': MessagesUnselected,
  'notifications-selected': NotificationsSelected,
  'notifications-unselected': NotificationsUnselected,
  'upswing-horizontal': UpswingHorizontal,
  'upspace-logo-mark': UpspaceLogoMark,
  'upspace-gradient-logo-mark': UpspaceGradientLogoMark,
  'upspace-word-mark': UpspaceWordMark,
  'upswing-vertical': UpswingVertical,
  'session-dumbbell': SessionDumbbell,
  stopwatch: StopWatch,
  upspace: Upspace,
  'send-message': SendMessage,
  'new-tab': NewTab,
  'user-profile': UserProfile,
  'play-rounded': Play,
  'post-complete-upswing': PostCompleteUpswing,
  'home-selected': HomeSelected,
  'home-unselected': HomeUnselected,
  'discover-unselected': DiscoverUnselected,
  'discover-selected': DiscoverSelected,
  'chat-selected': ChatSelected,
  'chat-unselected': ChatUnselected,
  reset: Reset,
  'small-gradient-circle-with-outline': SmallGradientCircleWithOutline,
  'small-gradient-circle': SmallGradientCircle,
  upscore: Upscore,
  'triangle-arrow': TriangleArrow,
}
